<template>
  <!-- <div class="py-2 px-0 text-xs max-w-screen-xl large:max-w-screen-large"> -->
  <div class="p-2 w-full text-xs">
    <div class="lg:grid lg:grid-cols-7 flex flex-col gap-x-2">
      <div
        class="overflow-auto ease-in-out transition-all duration-300"
        :class="
          sidebarOpen
            ? 'col-start-1 col-end-3 -translate-x-full'
            : 'col-start-1 col-end-1'
        "
      >
        <Sidebar
          :formParent="formParent"
          :class="!sidebarOpen ? 'hidden' : ''"
          :reportType="form.reportType"
          :disableScheduleButton="disableScheduleButton"
          @sensorDataSelected="updateSensorData"
          @showSidebar="setSidebarOpen"
          @formData="getReportData"
          @resetFormFromSidebar="resetFormFromSidebar"
        />

        <el-button
          id="collapse-button"
          size="mini"
          icon="el-icon-s-unfold"
          style="height: 40px"
          class="mb-2 border-custom-50"
          @click="setSidebarOpen(true)"
          v-if="!sidebarOpen"
          >Display Sidebar</el-button
        >
      </div>
      <div
        class="overflow-auto ease-in-out transition-all duration-300"
        :class="sidebarOpen ? 'col-start-3 col-end-8' : 'col-start-1 col-end-8'"
        v-loading="contentLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        element-loading-text="Please wait, we're preparing your Report..."
      >
        <div v-if="showReport">
          <ReportWrapper :form="formParent">
            <Content
              :loading="contentLoading"
              :reportData="reportData"
              @contentLoading="setLoadingState"
              @pdfSource="setPdfSource"
              @downloadPdf="setDownloadPdf"
              @downloadExcel="setDownloadExcel"
              @printReport="setPrintReport"
            />
          </ReportWrapper>
        </div>
        <div
          class="rounded-lg flex flex-col w-full px-4 h-full bg-primary-300 p-4 text-sm"
          v-else
        >
          <div class="text-white">
            <i class="el-icon-info"></i> Please select a filter first to display
            Report Data
          </div>
        </div>
      </div>
      <el-dialog
        title="Download Excel"
        :visible.sync="downloadExcelDialog"
        width="30%"
        :before-close="cancelDownloadExcel"
      >
        <h5 class="text-base font-bold text-black">Summary Data</h5>
        <div class="w-full mt-2">
          <el-select
            v-model="formParent.IsSummaryOnly"
            placeholder="Select Options"
          >
            <el-option
              v-for="item in summaryOnlyChoice"
              :disabled="item.disabled"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelDownloadExcel">Cancel</el-button>
          <el-button type="primary" @click="downloadExcelOption"
            >Submit</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import FileSaver from 'file-saver'
import Sidebar from '@/components/Reports/Sidebar'
import ReportWrapper from '@/components/Reports/ReportWrapper'
import Content from '@/components/Reports/Content'
import historicalPue from '@/assets/dummy/historicalPue'
import { mapGetters } from 'vuex'

export default {
  components: {
    Sidebar,
    ReportWrapper,
    Content
  },
  data() {
    return {
      formParent: {
        startDate: '',
        endDate: '',
        reportType: '',
        dataForm: 'daily',
        customer: '',
        IsSummaryOnly: true,
        username: ''
      },
      downloadExcelDialog: false,
      summaryOnlyChoice: [],
      historicalPue, // remove later
      content: true,
      contentLoading: false,
      showReport: false,
      reportData: {},
      form: {},
      sensorData: {},
      sidebarOpen: true,
      downloadPdf: false,
      downloadExcel: false,
      printReport: false,
      disableScheduleButton: true,
      pdfSource: {},
      excelFileName: ''
    }
  },
  mounted() {
    // console.log(this.$route.query)
    if (this.$route.query) {
      let data = this.$route.query
      this.formParent = {
        startDate: data.startDate,
        endDate: data.endDate,
        reportType: data.reportType,
        dataForm: data.dataForm,
        customer: data.customer,
        IsSummaryOnly: JSON.parse(data.IsSummaryOnly),
        username: data.username
      }
      // console.log(this.formParent)

      this.getReportData()
    }
  },
  computed: {
    ...mapGetters({
      progressFinished: 'progressFinished',
      downloadFinished: 'downloadFinished',
      printFinished: 'printFinished',
      userData: 'userData'
    }),
    menu() {
      return JSON.parse(JSON.stringify(this.$store.state.auth.menu))
    }
  },
  methods: {
    resetFormFromSidebar() {
      this.disableScheduleButton = true
    },
    setFormData: function (params) {
      this.form = params
      this.getReportData()
    },
    updateSensorData(val) {
      this.sensorData = val
    },
    setSidebarOpen(val) {
      this.sidebarOpen = val
    },
    setLoadingState(val) {
      this.contentLoading = val
    },
    setPdfSource(val) {
      this.pdfSource = val
    },
    displayExportNotification(type = 'done', _message = '') {
      if (type == 'start') {
        this.$notify.info({
          title: 'GENERATING REPORT',
          message: `This may take a few moments.`,
          type: 'success'
        })
      } else if (type == 'error') {
        this.$notify.error({
          title: 'SOMETHING WRONG HAPPENED',
          message: _message,
          type: 'success'
        })
      } else if (type == 'done') {
        let fileName = ''

        if (this.excelFileName !== '') fileName = this.excelFileName
        else fileName = this.pdfSource.filename

        this.$notify({
          title: 'REPORT IS READY',
          dangerouslyUseHTMLString: true,
          message: `<strong>'${fileName.trim()}'</strong> has been generated,<br/>Please check your download folder.`,
          type: 'success',
          duration: 10000
        })

        // reset excelFileName
        this.excelFileName = ''
      }
    },

    async setPrintReport(val) {
      await this.setLoadingState(val)
      this.printReport = val

      if (val) {
        this.displayExportNotification('start')
        this.printReportNow()
      }
    },
    async setDownloadPdf(val) {
      await this.setLoadingState(val)
      this.downloadPdf = val

      if (val) {
        var _this = this
        this.displayExportNotification('start')
        this.setLoadingState(true)

        // display notif first, then download the report
        setTimeout(function () {
          _this.downloadPdfReport()
        }, 1000)
      }
    },
    setDownloadExcel(val) {
      this.contentLoading = val
      this.downloadExcel = val

      if (val) {
        this.downloadExcelDialog = true
      }
    },
    downloadExcelOption() {
      this.displayExportNotification('start')
      this.downloadExcelReport()
      this.downloadExcelDialog = false
    },
    cancelDownloadExcel() {
      this.downloadExcelDialog = false
      this.setDownloadExcel(false)
    },
    async getReportData() {
      try {
        this.showReport = false
        this.contentLoading = true

        let url = this.$appInfo.api.generateJSonReport.ITMReport

        if (this.formParent.reportType === 'Power Billing') {
          this.formParent.location = ''
        } else if (this.formParent.reportType === 'Internal Racks per BU') {
          this.formParent.endDate = this.formParent.startDate
        } else if (this.formParent.reportType === 'Available Racks') {
          delete this.formParent.startDate
          delete this.formParent.endDate
        } else if (
          this.formParent.reportType === 'Customer Equipment Details'
        ) {
          delete this.formParent.startDate
          delete this.formParent.endDate
        } else if (
          this.formParent.reportType === 'Rack Utilization by Customer'
        ) {
          delete this.formParent.startDate
          delete this.formParent.endDate
          this.formParent.username = this.userData.Username
        } else {
          this.formParent.location = ''
        }

        // console.log(this.formParent)

        // this.formParent.IsSummaryOnly = this.formParent.IsSummaryOnly == 'true'
        this.formParent.IsSummaryOnly = JSON.parse(
          this.formParent.IsSummaryOnly
        )

        // submit report
        const res = await this.$axios.post(url, this.formParent)

        this.$router.push({
          query: Object.assign({}, this.$route.query, this.formParent)
        })

        this.reportData = {
          form: Object.assign({}, this.formParent),
          report: res.data
        }

        this.contentLoading = false
        this.showReport = true

        let permission = this.menu
          .filter((data) => data.items)
          .flatMap((permission) => permission.items)

        let scheduledPermission = permission.some(
          (data) => data.text == 'Scheduled Report'
        )

        scheduledPermission == true
          ? (this.disableScheduleButton = false)
          : (this.disableScheduleButton = true)
      } catch (e) {
        this.contentLoading = false
        this.disableScheduleButton = false
        console.log(e)
      }
    },

    async printReportNow() {
      try {
        // set report form title
        this.formParent.title = this.formParent.reportType

        await this.$store.dispatch('printPdf', this.pdfSource)
      } catch (e) {
        this.setDownloadPdf(false)
        console.log(e)
      }
    },
    // async downloadPdfReport() {
    //   try {
    //     // set report form title
    //     this.formParent.title = this.formParent.reportType

    //     await this.$store.dispatch('downloadPdf', this.pdfSource)
    //   } catch (e) {
    //     this.displayExportNotification('error', e)
    //     this.setDownloadPdf(false)
    //     console.log(e)
    //   }
    // },
    async fetchTagSummaryData(val) {
      try {
        const { data: res } = await this.$axios.get(
          `${this.$appInfo.api.tag.summaryData}?TagName=${val}`
        )
        this.summaryOnlyChoice = res
      } catch (e) {
        console.error(e)
      }
    },
    async downloadPdfReport() {
      try {
        this.contentLoading = true
        var _this = this

        // set report form title
        this.formParent.title = this.formParent.reportType
        this.formParent.username = this.userData.Username

        //PDF is summary only
        this.formParent.IsSummaryOnly = true

        let url = this.$appInfo.api.generatePdfReport.ITMReport
        // let tmpFormData = JSON.parse(JSON.stringify(this.form))

        if (this.formParent.reportType === 'Power Billing') {
          this.formParent.reportType = 'Power Billing'
        } else if (
          this.formParent.reportType === 'Power by Customer per Location'
        ) {
          this.formParent.reportType = 'Power by Customer per Location'
        } else if (this.formParent.reportType === 'Internal Racks per BU') {
          this.formParent.reportType = 'Internal Racks per BU'
        } else if (this.formParent.reportType === 'Available Racks') {
          this.formParent.reportType = 'Available Racks'
        } else if (
          this.formParent.reportType === 'Rack Utilization by Customer'
        ) {
          this.formParent.reportType = 'Rack Utilization by Customer'
        } else if (
          this.formParent.reportType === 'Customer Equipment Details'
        ) {
          this.formParent.reportType = 'Customer Equipment Details'
        } else if (this.formParent.reportType === 'Customer Trend') {
          this.formParent.reportType = 'Customer Trend'
        }

        await this.$axios
          .post(url, this.formParent, {
            responseType: 'blob'
          })
          .then((response) => {
            // response.data is a blob type
            const fileName = this.pdfSource.filename

            FileSaver.saveAs(response.data, fileName)

            _this.displayExportNotification()
          })

        this.setDownloadExcel(false)
        this.contentLoading = false
      } catch (e) {
        this.displayExportNotification('error', e)
        this.contentLoading = false
        console.log(e)
      }
    },
    async downloadExcelReport() {
      try {
        this.contentLoading = true
        var _this = this

        // set report form title
        this.formParent.title = this.formParent.reportType
        this.formParent.username = this.userData.Username

        let url = this.$appInfo.api.generateExcelReport.ITMReport
        // let tmpFormData = JSON.parse(JSON.stringify(this.form))

        if (this.formParent.reportType === 'Power Billing') {
          this.formParent.reportType = 'Power Billing'
        } else if (
          this.formParent.reportType === 'Power by Customer per Location'
        ) {
          this.formParent.reportType = 'Power by Customer per Location'
        } else if (this.formParent.reportType === 'Internal Racks per BU') {
          this.formParent.reportType = 'Internal Racks per BU'
        } else if (this.formParent.reportType === 'Available Racks') {
          this.formParent.reportType = 'Available Racks'
        } else if (
          this.formParent.reportType === 'Rack Utilization by Customer'
        ) {
          this.formParent.reportType = 'Rack Utilization by Customer'
        } else if (
          this.formParent.reportType === 'Customer Equipment Details'
        ) {
          this.formParent.reportType = 'Customer Equipment Details'
        } else if (this.formParent.reportType === 'Customer Trend') {
          this.formParent.reportType = 'Customer Trend'
        }

        await this.$axios
          .post(url, this.formParent, {
            responseType: 'blob'
          })
          .then((response) => {
            // response.data is a blob type
            const fileName = this.pdfSource.filename.replace('pdf', 'xlsx')
            // var fileName = `Report ${this.formParent.title} ${Date.now()}.xlsx`
            this.excelFileName = fileName

            FileSaver.saveAs(response.data, fileName)

            _this.displayExportNotification()
          })

        this.setDownloadExcel(false)
        this.contentLoading = false
      } catch (e) {
        this.displayExportNotification('error', e)
        this.contentLoading = false
        console.log(e)
      }
    }
  },
  watch: {
    downloadFinished(val) {
      if (val) {
        this.setDownloadPdf(false)
        this.displayExportNotification()

        // revert status
        this.$store.commit('RESET_PROGRESS')
      }
    },
    printFinished(val) {
      if (val) {
        this.setDownloadPdf(false)

        // revert status
        this.$store.commit('RESET_PROGRESS')
      }
    },
    'formParent.reportType': function (val) {
      this.formParent.IsSummaryOnly = true
      this.disableScheduleButton = true
      this.formParent = {
        startDate: '',
        endDate: '',
        reportType: val,
        location: '',
        dataForm: 'daily',
        customer: '',
        IsSummaryOnly: true,
        username: ''
      }
      this.fetchTagSummaryData(val)
      this.formParent.title = val
    }
  }
}
</script>

<style>
.el-notification__title {
  font-weight: 700 !important;
  font-size: 16px !important;
  color: #303133 !important;
  margin: 0 !important;
}
</style>
